import { render, staticRenderFns } from "./InjuryReport.vue?vue&type=template&id=5e66e3ca&scoped=true"
import script from "./InjuryReport.vue?vue&type=script&lang=js"
export * from "./InjuryReport.vue?vue&type=script&lang=js"
import style0 from "./InjuryReport.vue?vue&type=style&index=0&id=5e66e3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e66e3ca",
  null
  
)

export default component.exports